<template>
  <div :class="classes.content">
    <Header :eventId="eventId" />
    <div :class="[classes.cardContent, 'win-draw-win']">
      <div :class="classes.marketOptions">
        <WinOption
          :stagger="0"
          :class="[classes.marketOption, 'team-one']"
          :eventId="eventId"
          :optionId="ftrMarkets[0].options[0]"
        />
        <WinOption
          :eventId="eventId"
          :stagger="2"
          :class="[classes.marketOption, 'draw']"
          :optionId="ftrMarkets[0].options[1]"
        />
        <WinOption
          :stagger="4"
          :class="[classes.marketOption, 'team-two']"
          :eventId="eventId"
          :optionId="ftrMarkets[0].options[2]"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import { defineComponent, ref } from "vue";
import WinOption from "../../WinOptionMobile.vue";
import {
  composeHomeAwayOptions,
  composeEventCompetitors
} from "@fresh8/ad-data-composition/src/betData";
import Header from "../../HeaderInternal.vue";

const useStyles = createUseStyles({
  content: {
    display: "flex",
    flexDirection: "row",
    padding: "4px 4px 0px 4px",
    height: "inherit"
  },
  cardContent: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    alignItems: "center"
  },
  marketOptions: {
    flex: 1,
    display: "flex",
    width: "100%"
  },
  marketOption: {
    "&.draw .odds-text": {
      paddingLeft: "4px",
      paddingRight: "4px",
      minWidth: "50px",
      textAlign: "center"
    },
    "&:first-of-type": {
      flex: "1 1 36%"
    },
    "&:last-of-type": {
      flex: "1 1 36%"
    },

    "& .meta-text": {
      fontSize: "7px"
    },
    "& .odds-text": {
      fontSize: "12px"
    },

    "& a": {
      padding: "1px 0"
    }
  }
});

export default defineComponent({
  name: "MobileLeaderboardWDW",
  components: {
    Header,
    WinOption
  },
  props: {
    marketId: { type: String, required: true },
    eventId: { type: String, required: true }
  },
  setup(props) {
    const marketId = ref([props.marketId]);
    const classesRef = useStyles();
    const ftrMarkets = composeHomeAwayOptions(marketId);
    const competitors = composeEventCompetitors(props.eventId);

    return {
      competitors,
      classes: classesRef,
      ftrMarkets
    };
  }
});
</script>

<style></style>
